import React from 'react';
import { MdAddShoppingCart } from 'react-icons/md';
import { useMediaQuery } from 'usehooks-ts';
import Icon from '../../../../components/ReactIcon';
import { ShopDTO } from '../../../../DTO/shopResponseDTO';
import {
    CartServiceType,
    CartValuesServiceStore,
    useShoppingCartStore,
} from '../../../../store/shoppingCart/shoppingCartStore';
import {
    ButtonShop,
    CardShopWrapper,
    DetailsShopWrapper,
    VideoScreen,
} from './styles';
import { Format } from '../../../../helpers/formatters';

type CardShopProps = {
    itemShop: ShopDTO;
    date: Date;
    handleAddToCart: (cartCurrentValue: CartValuesServiceStore) => void;
};

export const CardShop: React.FC<CardShopProps> = ({
    itemShop: { id, description, exhibitionName, image, value },
    date,
    handleAddToCart,
}) => {
    const matchQuery = useMediaQuery('(min-width: 768px)');
    const cartIsVisible = useShoppingCartStore(state => state.cartIsVisible);

    return (
        <CardShopWrapper>
            <VideoScreen src={image} alt={exhibitionName} />
            <DetailsShopWrapper>
                <h3>{exhibitionName}</h3>
                {matchQuery && !cartIsVisible && (
                    <span className="description" title={description}>
                        {description}
                    </span>
                )}
            </DetailsShopWrapper>
            <ButtonShop
                onClick={() =>
                    handleAddToCart({
                        id: String(id),
                        title: exhibitionName,
                        value,
                        date,
                        type: CartServiceType.Park,
                    })
                }
            >
                <Icon Icon={MdAddShoppingCart} size={'1.25rem'} />
                {Format.currencyWithoutFraction(value)}
            </ButtonShop>
        </CardShopWrapper>
    );
};
